/** @format */

const template = `
<article
  ng-if="$ctrl.attainment"
  class="courseunit {{ $ctrl.getColorCategory() }}"
  ng-class="{'dimmed': $ctrl.dimmed, 'selected': $ctrl.selected}">
  <div class="courseunit-top-row">
    <div class="credits-box">
      <sis-tooltip
        tooltip-text="{{'SIS_COMPONENTS.NUMBER.ATTAINED_CREDITS' |translate: {credits: $ctrl.attainment.credits} }}"
        [append-to-body]="true">
        <span class="credit-amount sis-tooltip-trigger-content"> {{$ctrl.attainment.credits}} </span> </sis-tooltip
      ><!--
            --><span class="credit-abbreviation" translate="CREDITS"></span> </div
    ><!--
        --><div class="grade-box">
      <sis-icon icon="achievement"></sis-icon>
      <span class="grade-text">{{ $ctrl.grade.abbreviation | localizedString }}</span> </div
    ><!--
        --><div class="title-box">
      <span class="courseunit-code">
        <span class="no-icon">
          <button
            type="button"
            class="link-button"
            ng-click="$ctrl.openInfoModal()"
            aria-label="{{$ctrl.attainment.code}} {{$ctrl.attainment.name | localizedString}} {{'ARIA_LABEL.OPEN_INFO' | translate}}">
            <sis-icon icon="brochure"></sis-icon>{{$ctrl.attainment.code}}
          </button>
        </span> </span
      ><!--
         --><span
        ng-if="$ctrl.attainment.documentState==='DRAFT' || $ctrl.attainment.documentState==='DELETED'"
        class="tiny-badge"
        ng-class="{'accent': $ctrl.attainment.documentState==='DRAFT', 'danger': $ctrl.attainment.documentState==='DELETED'}">
        {{ $ctrl.attainment.documentState | translate}}
      </span>
      <sis-tooltip [append-to-body]="true" tooltip-class="tooltip-wide">
        <span class="sis-tooltip-trigger-content courseunit-title" aria-label="{{$ctrl.titleAriaLabel}}"
          ><span aria-hidden="true">{{$ctrl.attainment.name | localizedString}}</span></span
        >
        <div class="sis-tooltip-content plan-structure-study-tooltip">
          <div class="study-name">{{$ctrl.attainment.name | localizedString}}</div>
          <div class="first-level" translate="SIS_COMPONENTS.PLAN.STUDY_TOOLTIP.CUSTOM_ATTAINMENT"></div>
        </div>
      </sis-tooltip> </div
    ><!--
   --><ng-transclude
    ></ng-transclude>
  </div>
  <div class="cu-notification-bar">
    <sis-tooltip
      ng-if="$ctrl.isInvalidSelection($ctrl.attainment) && !$ctrl.hasModuleContentApproval($ctrl.attainment)"
      tooltip-text="{{'PLAN.INVALID_SELECTIONS.NOTIFICATION' | translate}}">
      <div class="cu-notification sis-tooltip-trigger-content">
        <span class="cu-notification-header"><sis-icon icon="alert-fill"></sis-icon></span
        ><!--
             --><span class="cu-notification-content"
          ><!--
                    --><span ng-if="!$ctrl.courseUnit.errorDetails" translate>PLAN.INVALID_SELECTIONS.NOTIFICATION</span>
        </span>
      </div>
    </sis-tooltip>
    <sis-tooltip
      ng-if="$ctrl.isInvalidAccordingToModuleContentApproval($ctrl.attainment)"
      tooltip-text="{{'PLAN.INVALID_ACCORDING_TO_MODULE_CONTENT_APPROVAL.NOTIFICATION' | translate}}">
      <div class="cu-notification sis-tooltip-trigger-content">
        <span class="cu-notification-header"><sis-icon icon="alert-fill"></sis-icon></span
        ><!--
             --><span class="cu-notification-content">
          <span translate="PLAN.INVALID_ACCORDING_TO_MODULE_CONTENT_APPROVAL.NOTIFICATION"></span>
        </span>
      </div>
    </sis-tooltip>
    <sis-tooltip
      ng-if="$ctrl.expiryDate"
      tooltip-text="{{'PLAN.COURSE_UNIT.EXPIRATION_IMMINENT' | translate}} {{$ctrl.expiryDate | localDateFormat}}.">
      <div class="cu-notification sis-tooltip-trigger-content">
        <span class="cu-notification-header"><sis-icon icon="alert-fill"></sis-icon></span
        ><!--
             --><span class="cu-notification-content">
          <span translate="PLAN.COURSE_UNIT.EXPIRATION_IMMINENT"></span>
          {{$ctrl.expiryDate | localDateFormat}}.
        </span>
      </div>
    </sis-tooltip>
    <div ng-if="$ctrl.showCourseUnitAttainmentNotification && $ctrl.isStudentPage()" class="course-unit-attainment-notification">
      <div class="sis-px-xxs">
        <span><sis-icon icon="info-circle-fill"></sis-icon> {{ 'PLAN.COURSE_UNIT_ATTAINED' | translate }}</span>
        <button type="button" ng-click="$ctrl.openAttainmentDetailsModal()" class="btn btn-primary btn-naked btn-sm" translate>
          {{'PLAN.SHOW_ATTAINMENT_DETAILS' | translate }}
        </button>
      </div>
    </div>
  </div>
</article>
<article ng-if="!$ctrl.attainment" class="courseunit attainment-data-not-found">
  <div class="courseunit-top-row">
    <div class="credits-box"> <sis-icon icon="alert-fill" class="centered-icon"></sis-icon> </div
    ><!--
        --><div class="grade-box"> <sis-icon icon="achievement"></sis-icon> </div
    ><!--
        --><div class="title-box">
      <span class="courseunit-code">
        <span class="no-icon"> </span>
      </span>
      <sis-tooltip
        [append-to-body]="true"
        [tooltip-text]="'SIS_COMPONENTS.CUSTOM_COURSE_UNIT_ATTAINMENT_BOX.ATTAINMENT_DATA_NOT_FOUND' | translate">
        <span class="courseunit-title sis-tooltip-trigger-content">
          {{'SIS_COMPONENTS.CUSTOM_COURSE_UNIT_ATTAINMENT_BOX.ATTAINMENT_DATA_NOT_FOUND' | translate}}
        </span>
      </sis-tooltip> </div
    ><!--
   --><ng-transclude
    ></ng-transclude>
  </div>
</article>
`;
export default template;
